var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{attrs:{"icon":"fad fa-car-mechanic","title":"Zakázky"}}),_c('OrdersGrid',{staticClass:"mb-4"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }